import { ReactNode, useContext, useEffect, useRef, useState } from 'react'
import { ICON_CHEVRON_DOWN_GRAY700, ICON_CHEVRON_UP_GRAY700 } from '../../../../modules/svg/svg'
import { AccordionContext } from '../highlight/AccordionContainer'
import Card from './Card'

const dividerMargin = 16

const Accordion = ({
  children,
  title,
  className,
  idx,
  errHeight = 0,
  hasNoCorrectSentence = false,
}: {
  children: ReactNode
  title: ReactNode
  className?: string
  idx?: number
  errHeight?: number | string
  hasNoCorrectSentence?: boolean
}) => {
  const childRef = useRef<HTMLDivElement>(null)
  const parentRef = useRef<HTMLDivElement>(null)
  const { height } = useHeight(childRef)
  const [getAccordionContext, setAccordionContext] = useContext(AccordionContext)
  const isOpen = getAccordionContext === idx

  useEffect(() => {
    if (!isOpen) {
      parentRef.current.style.height = '0px'
    }
  }, [isOpen])

  useEffect(() => {
    if (isOpen) {
      parentRef.current.style.height = `${height + (!hasNoCorrectSentence ? dividerMargin * 2 : 0) + +errHeight}px`
    }
  }, [height, hasNoCorrectSentence, isOpen, errHeight])

  const onOffContent = (event = null) => {
    event?.stopPropagation()
    if (parentRef.current === null) return
    setAccordionContext(isOpen ? -1 : idx)
  }
  return (
    <Card clx={className + ' shadow-[0_1px_5px_0_rgba(0,0,0,0.07)] bg-white'}>
      <div className="iteisOpenms-center flex" onClick={onOffContent}>
        <div className="w-full">{title}</div>
        <span className="mt-[4px] ml-[4px] flex-shrink-0 self-start">
          <img src={!isOpen ? ICON_CHEVRON_DOWN_GRAY700 : ICON_CHEVRON_UP_GRAY700} alt="arrow" />
        </span>
      </div>
      <div className="transition-height h-0 overflow-hidden duration-150" ref={parentRef}>
        {!hasNoCorrectSentence && (
          <div
            className="my-[16px] border-b border-gray-100"
            style={{ marginTop: dividerMargin, marginBottom: dividerMargin }}
          />
        )}
        <div ref={childRef}>{children}</div>
      </div>
    </Card>
  )
}

export default Accordion

const useHeight = (ref): { height: number } => {
  const [height, setHeight] = useState(0)

  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === ref.current) {
          const { height } = entry.contentRect
          setHeight(height)
        }
      }
    })

    if (ref.current) {
      resizeObserver.observe(ref.current)
    }

    return () => {
      resizeObserver.disconnect()
    }
  }, [ref])

  return { height }
}
